'use strict';
const $ = jQuery.noConflict();
$(function() {
	const blogListing = {
		currentCategory: '',
		currentPage: 1,
		requestInFlight: false,

		init: function() {
			this.cacheDOM();
			if (!this.$root.length) return;
			this.bindEvents();
		},

		cacheDOM: function() {
			this.$root = $('.blog-listing');
			this.$tabs = $('.js-blog-listing-tab');
			this.$empty = $('.js-blog-listing-empty');
			this.$grid = $('.js-blog-listing-grid');
			this.$loadMoreWrap = $('.js-blog-listing-load-more-wrap');
			this.$loadMoreBtn = $('.js-blog-listing-load-more');
			this.ajaxAction = this.$root.data('ajax-action');
			this.currentCategory = this.$root.data('default-category') || '';
		},

		bindEvents: function() {
			this.$tabs.on('click', this.onTabClick.bind(this));
			this.$loadMoreBtn.on('click', this.onLoadMoreClick.bind(this));
		},

		onTabClick: function(event) {
			const $tab = $(event.currentTarget);
			if ($tab.hasClass('is-active')) return;

			this.$tabs.removeClass('is-active').attr('aria-selected', 'false');
			$tab.addClass('is-active').attr('aria-selected', 'true');
			this.currentCategory = $tab.data('category') || '';

			this.fetchResults(true);
		},

		onLoadMoreClick: function() {
			this.fetchResults(false);
		},

		fetchResults: function(reset) {
			if (this.requestInFlight) return;

			const page = reset ? 1 : this.currentPage + 1;
			const data = {
				action: this.ajaxAction,
				category: this.currentCategory,
				page: page,
			};

			this.requestInFlight = true;
			this.toggleLoading(true);

			$.ajax({
				method: 'POST',
				url: window.fwsLocalized.ajaxUrl,
				data: data,
				success: (response) => this.onSuccess(response, reset, page),
				error: this.onError,
				complete: () => {
					this.requestInFlight = false;
					this.toggleLoading(false);
				},
			});
		},

		onSuccess: function(response, reset, page) {
			if (!response.success || !response.data) return;
			const data = response.data;

			if (reset) {
				this.$grid.html(data.html || '');
			} else if (data.html) {
				this.$grid.append(data.html);
			}

			this.currentPage = data.page || page;
			this.$loadMoreWrap.prop('hidden', !data.hasMore);
			this.$empty.prop('hidden', data.total > 0);
			this.$grid.prop('hidden', data.total === 0);
		},

		onError: function(jqXHR, textStatus, errorThrown) {
			console.error('AJAX error: ' + textStatus + ' - ' + errorThrown);
		},

		toggleLoading: function(state) {
			this.$loadMoreWrap.toggleClass('show-spinner', state);
			this.$root.toggleClass('is-loading', state);
		},
	};

	blogListing.init();
});
